import { useFetch, useUser } from '@ztechapps/common.hook'
import { jsonStringify } from '@ztechapps/common.utils'

export const useCreateAchSource = (createAchSourceUrl) => {
  const { accessToken } = useUser()
  const [createBankInfo, { error, loading }] = useFetch(createAchSourceUrl)

  const createSource = async ({ email, amount, metadata }) => {
    const input = { amount, email, metadata }

    const achInfo = await createBankInfo({
      method: 'POST',
      headers: {
        'totalmilk-login-token': accessToken,
      },
      body: jsonStringify(input),
    })

    return achInfo
  }

  return [createSource, { error, loading }]
}
